var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "calendar-header" }, [
    _c(
      "div",
      { staticClass: "period-label" },
      [
        _vm._t("label", function () {
          return [
            _c(
              "div",
              { staticClass: "period-label-elements" },
              _vm._l(_setup.periodLabelElements, function (part) {
                return _c(
                  "div",
                  { key: part.key, class: { "period-year": part.isYear } },
                  [_vm._v("\n          " + _vm._s(part.text) + "\n        ")]
                )
              }),
              0
            ),
          ]
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "calendar-header-nav" },
      _vm._l(_setup.buttons, function ({ key, ariaLabel, content, date }) {
        return _c(
          "b-button",
          {
            key: key,
            class: key,
            attrs: {
              variant: "secondary",
              disabled: !date,
              "aria-label": ariaLabel,
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _setup.emit("input", date)
              },
            },
          },
          [
            typeof content === "object"
              ? _c(_setup.Icon, { attrs: { icon: content } })
              : _c("span", [_vm._v(_vm._s(content))]),
          ],
          1
        )
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }